import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import {
    defaultColorEnhance,
    type ImageEnhancePlugin,
} from '@meitu/saas-editor-core/es/layers/main-layer/plugins/apps/user-editor/image-enhance';
import { useBatchActionHooks } from '../batch-action-hooks';
import EnhanceSlider from '../enhance-slider';
import Reset from '../reset';
import { IEnhanceFeatureProps, IEnhanceSlider } from '../types';
import { getSliderConfig } from './config';

export const ColorFeature: React.FC<IEnhanceFeatureProps> = ({
    editor,
    theme,
    onReset,
    onBeforeEnhance,
    onEnhance,
    onAfterEnhance,
    trackFunc,
    isBatchEditor,
    setStageLoading,
    batchSetIsLoading,
    setIsDisable,
}) => {
    const { batchAction } = useBatchActionHooks();
    const { basicEnhance } = editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin');
    const [enhanceState, _setEnhanceState] = useState(
        editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin').getState(),
    );

    useEffect(() => {
        return editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin').watch((state) => _setEnhanceState(state));
    }, [editor]);

    const { colorEnhance } = enhanceState;

    const [sliderSkin, setSliderSkin] = useState<IEnhanceSlider[]>([]);

    useEffect(() => {
        setSliderSkin(getSliderConfig(theme));
    }, [theme]);

    return (
        <>
            <div>
                {sliderSkin.map((v, i) => {
                    return (
                        <EnhanceSlider
                            key={i}
                            maxVal={v.maxVal}
                            minVal={v.minVal}
                            value={colorEnhance[v.featureType][v.keyName]}
                            title={v.name}
                            opacityOpposite={v.opacityOpposite}
                            onChange={async (val: number) => {
                                const newParams = cloneDeep(colorEnhance);

                                newParams[v.featureType][v.keyName] = val;

                                editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin').setColorEnhance(newParams);
                                onBeforeEnhance?.(v.keyName, val);
                                await basicEnhance.action(newParams, trackFunc);
                                onEnhance?.(v.keyName, val);
                            }}
                            onAfterChange={async (val) => {
                                if (isBatchEditor) {
                                    const newParams = cloneDeep(colorEnhance);

                                    newParams[v.featureType][v.keyName] = val;
                                    batchAction(
                                        editor,
                                        newParams,
                                        (stageIndex: number, isBatch: boolean) => {
                                            setStageLoading?.(stageIndex, isBatch);
                                        },
                                        setIsDisable,
                                        batchSetIsLoading,
                                    );
                                }
                                onAfterEnhance?.(v.keyName, val);
                            }}
                            background={v.background}
                            wrapBackground={v.wrapBackground}
                        />
                    );
                })}
            </div>
            <Reset
                onClick={async () => {
                    const newParams = cloneDeep(defaultColorEnhance);

                    editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin').setColorEnhance(newParams);
                    if (isBatchEditor) {
                        setIsDisable?.(true);
                        await basicEnhance.batchReset();
                        setIsDisable?.(false);
                    } else {
                        basicEnhance.action(newParams);
                    }

                    onReset?.();
                }}
            />
        </>
    );
};
